import { render, staticRenderFns } from "./goodStock.vue?vue&type=template&id=0f426e52&"
import script from "./goodStock.vue?vue&type=script&lang=js&"
export * from "./goodStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f426e52')) {
      api.createRecord('0f426e52', component.options)
    } else {
      api.reload('0f426e52', component.options)
    }
    module.hot.accept("./goodStock.vue?vue&type=template&id=0f426e52&", function () {
      api.rerender('0f426e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/saleTrade/goodStock.vue"
export default component.exports